import SidebarMenuTab from './SidebarMenuTab'

export default SidebarMenuTab
